/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Ocop_Issuer_National1Inputs */

const vi_sitesettings_ocop_issuer_national1 = /** @type {(inputs: Sitesettings_Ocop_Issuer_National1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị chứng nhận cấp quốc gia`)
};

/**

* @param {Sitesettings_Ocop_Issuer_National1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_ocop_issuer_national1 = /** @type {((inputs?: Sitesettings_Ocop_Issuer_National1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Ocop_Issuer_National1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_ocop_issuer_national1(inputs)
});
export { sitesettings_ocop_issuer_national1 as "siteSettings_ocop_issuer_national" }